import { useReducer } from 'react'
import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'
import { useIntl } from 'react-intl'

export const ActionType = {
  SET_PLAN_BILL: 'SET_PLAN_BILL',
  SET_ACCUMULATE: 'SET_ACCUMULATE',
  SET_BILLING_PAYMENT: 'SET_BILLING_PAYMENT',
  SET_LOADED: 'SET_LOADED',
}

const initialState = {
  planBill: {},
  accumulate: [],
  payment: {},
  isLoading: true,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_PLAN_BILL:
      return {
        ...state,
        planBill: action.payload,
      }
    case ActionType.SET_ACCUMULATE:
      return {
        ...state,
        accumulate: action.payload,
      }
    case ActionType.SET_BILLING_PAYMENT:
      return {
        ...state,
        payment: action.payload,
      }
    case ActionType.SET_LOADED:
      return {
        ...state,
        isLoading: false,
      }
    default:
      return state
  }
}

export default function usePlanBilling() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()

  const fetchBillingPlan = () => {
    effects.apis
      .getBillingPlan()
      .then((response) => {
        dispatch({ type: 'SET_PLAN_BILL', payload: response })
      })
      .catch(() => {
        dispatch(
          MessageAlert.showError({
            message: formatMessage({ id: 'error.general' }),
          }),
        )
      })
  }

  const fetchBillingAccumulateUsage = (
    startDate = '',
    endDate = '',
    showAll = true,
  ) => {
    effects.apis
      .getBillingAccumulateUsage({ showAll })
      .then((response) => {
        dispatch({ type: 'SET_ACCUMULATE', payload: response })
      })
      .catch(() => {
        dispatch(
          MessageAlert.showError({
            message: formatMessage({ id: 'error.general' }),
          }),
        )
      })
  }

  const fetchBillingPayment = () => {
    effects.apis
      .getBillingPayment()
      .then((response) => {
        dispatch({ type: 'SET_BILLING_PAYMENT', payload: response })
      })
      .catch(() => {
        dispatch(
          MessageAlert.showError({
            message: formatMessage({ id: 'error.general' }),
          }),
        )
      })
  }

  const handleFetchPlanAndBilling = async () => {
    await fetchBillingPlan()
    await fetchBillingAccumulateUsage()
    await fetchBillingPayment()
    dispatch({ type: 'SET_LOADED' })
  }

  const handleFetchPaymentAddress = async () => {
    await fetchBillingPayment()
  }

  return {
    state,
    handleFetchPlanAndBilling,
    handleFetchPaymentAddress,
  }
}
